// src/components/directory/ProgramGrid.jsx
// Covers: PL-01 (key facts on cards) PL-05 (matched programs float up)

import React from 'react';
import ProgramCard from './ProgramCard';
import styles from './ProgramGrid.module.css';

export default function ProgramGrid({ programs, loading, error, hasWizardAnswers, onProgramClick }) {
  if (loading) return (
    <div className={styles.state}>
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
      <div className={styles.skeleton} />
    </div>
  );

  if (error) return (
    <div className={styles.stateMsg}>
      <p>Something went wrong loading programs. Please refresh and try again.</p>
    </div>
  );

  if (!programs.length) return (
    <div className={styles.stateMsg}>
      <p>No programs match your current filters.</p>
      <p className={styles.stateSub}>Try broadening your search or removing a filter.</p>
    </div>
  );

  const matched   = hasWizardAnswers ? programs.filter(p => (p.matchScore || 0) >= 1) : [];
  const unmatched = hasWizardAnswers ? programs.filter(p => (p.matchScore || 0) === 0) : programs;

  return (
    <div>
      <div className={styles.resultsBar}>
        <span className={styles.count}>
          <strong>{programs.length}</strong> program{programs.length !== 1 ? 's' : ''} shown
          {matched.length > 0 && (
            <span className={styles.matchCount}> · {matched.length} match your answers</span>
          )}
        </span>
      </div>

      <div className={styles.grid}>
        {/* Matched programs first */}
        {matched.map((p, i) => (
          <ProgramCard
            key={p.id}
            program={p}
            isMatch={true}
            animationDelay={i * 50}
            onClick={() => onProgramClick(p)}
          />
        ))}

        {/* Divider between matched and unmatched */}
        {matched.length > 0 && unmatched.length > 0 && (
          <div className={styles.divider}>
            <span>Other programs</span>
          </div>
        )}

        {/* All other programs */}
        {unmatched.map((p, i) => (
          <ProgramCard
            key={p.id}
            program={p}
            isMatch={false}
            animationDelay={(matched.length + i) * 50}
            onClick={() => onProgramClick(p)}
          />
        ))}
      </div>
    </div>
  );
}
